<template>
  <div id="smartTown" class="product-page">
    <!-- 标题区域 -->
    <h1 class="page-title">新质餐厅智能识别支付系统</h1>

    <!-- 正文内容区域 -->
    <div class="page-content">
      <!-- 第1章 产品概述 -->
      <div class="text-section">
        <h2 class="chapter-title">一、产品概述</h2>
        <p class="content-paragraph">
          新质餐厅智能识别支付系统以 AI 视觉识别为核心，通过餐盘与菜品的图像特征建模，实现自选餐线的自动识别、自动计价与自动结算。就餐者取餐后置于结算台，系统快速完成多目标识别并生成账单，配合刷脸、扫码、一卡通等支付方式完成无感支付，替代传统人工打价排队结算的模式。
        </p>
        <p class="content-paragraph">
          系统在结算效率之外延伸出经营与营养两条能力线：面向餐厅管理者提供客流时段分析、菜品销售排行、备餐量预测、食材进销存与成本核算；面向就餐者提供营养成分核算、膳食结构与健康建议。系统同时支持企业补贴、月结账单与多档口统一管理，适用于机关企事业单位食堂、高校与医院营养餐厅、产业园区与连锁餐饮等场景。
        </p>

        <!-- 核心能力 -->
        <div class="capability-grid">
          <div class="capability-card">
            <h3 class="capability-title">智能识别结算</h3>
            <ul class="capability-list"><li>餐盘识别</li><li>菜品识别</li><li>多目标混识</li><li>重量计价</li><li>自动出账</li><li>漏识复核</li><li>异常拦截</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">多元支付账户</h3>
            <ul class="capability-list"><li>刷脸支付</li><li>扫码支付</li><li>一卡通</li><li>企业补贴</li><li>月结账单</li><li>发票开具</li><li>账户充值</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">经营与营养</h3>
            <ul class="capability-list"><li>客流分析</li><li>菜品排行</li><li>备餐预测</li><li>进销存</li><li>成本核算</li><li>营养核算</li><li>膳食建议</li></ul>
          </div>
        </div>
      </div>

      <!-- 第2章 产品截图 -->
      <div class="text-section">
        <h2 class="chapter-title">二、产品截图</h2>
        <p class="shot-note">以下为系统功能示意，实际界面以项目交付成果为准。</p>
        <div class="shot-grid">
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/ct-settle.svg"
              alt="海南华德科技有限公司 新质餐厅智能识别支付系统 - 就餐端 · 刷脸支付与账单查询"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">01</span>就餐端 · 刷脸支付与账单查询
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/ct-monitor.svg"
              alt="海南华德科技有限公司 新质餐厅智能识别支付系统 - 结算监控 · 识别复核与订单管理"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">02</span>结算监控 · 识别复核与订单管理
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/ct-board.svg"
              alt="海南华德科技有限公司 新质餐厅智能识别支付系统 - 运营看板 · 客流量与成本分析"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">03</span>运营看板 · 客流量与成本分析
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/ct-admin.svg"
              alt="海南华德科技有限公司 新质餐厅智能识别支付系统 - 菜品档口 · 价格与库存管理"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">04</span>菜品档口 · 价格与库存管理
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
};
</script>
<style scoped>
/* 全局容器样式 */
.product-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: "Poppins", "Microsoft YaHei", "PingFang SC", sans-serif;
  background-color: var(--light-bg);
  min-height: 100vh;
}

/* 标题样式 */
.page-title {
  font-weight: 700;
  font-size: 32px;
  color: var(--text-color);
  text-align: center;
  margin: 0 auto 50px;
  padding-bottom: 15px;
  border-bottom: 3px solid var(--primary-color1);
  display: inline-block;
  width: 100%;
  letter-spacing: 1px;
}

/* 内容容器 */
.page-content {
  background-color: var(--white);
  padding: 50px 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* 章节区域 */
.text-section {
  margin: 20px 0 60px;
}
.text-section:last-child {
  margin-bottom: 20px;
}

/* 章节标题 */
.chapter-title {
  font-weight: 700;
  font-size: 20px;
  color: var(--text-color);
  margin: 10px 0 25px;
  padding-left: 10px;
  border-left: 4px solid var(--primary-color1);
  line-height: 1.4;
}

/* 正文段落 */
.content-paragraph {
  line-height: 1.8;
  font-weight: 400;
  color: var(--text-color2);
  margin: 8px 0 22px;
  text-indent: 2em;
  font-size: 16px;
  text-align: justify;
}
.content-paragraph strong {
  color: var(--primary-color1);
  font-weight: 600;
}

/* 核心能力卡片 */
.capability-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 30px;
}
.capability-card {
  background-color: var(--light-bg);
  border-radius: 10px;
  padding: 22px 20px;
  border-top: 3px solid var(--primary-color1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.capability-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}
.capability-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-color);
  margin: 0 0 14px;
}
.capability-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.capability-list li {
  display: inline-block;
  background-color: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 4px 12px;
  margin: 0 6px 8px 0;
  font-size: 13px;
  color: var(--text-color2);
  transition: all 0.3s ease;
}
.capability-list li:hover {
  border-color: rgba(230, 0, 76, 0.35);
  color: var(--primary-color1);
}

/* 产品截图 */
.shot-note {
  font-size: 13px;
  color: var(--text-color3);
  margin: -10px 0 22px;
}
.shot-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}
.shot-card {
  margin: 0;
  background: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}
.shot-card:hover {
  transform: translateY(-4px);
  border-color: rgba(230, 0, 76, 0.25);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06), 0 10px 28px rgba(0, 0, 0, 0.08);
}
.shot-card img {
  display: block;
  width: 100%;
  height: auto;
}
.shot-card figcaption {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  font-size: 14px;
  color: var(--text-color);
  border-top: 1px solid #f2f2f2;
  background: var(--white);
}
.shot-index {
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 700;
  color: var(--primary-color1);
  background: rgba(230, 0, 76, 0.08);
  border-radius: 4px;
  padding: 2px 7px;
}

/* 响应式 */
@media (max-width: 991px) {
  .capability-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  .product-page {
    padding: 24px 14px;
  }
  .page-title {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .page-content {
    padding: 28px 18px;
  }
  .capability-grid,
  .shot-grid {
    grid-template-columns: 1fr;
  }
  .content-paragraph {
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/softwareWs13.vue